import React, { useEffect } from 'react';
import { toast } from 'react-hot-toast';
import { useNavigate } from 'react-router-dom';

import { useAuth } from '../../../../contexts/AuthContext';
import { supabase } from '../../../../services/supabase';

export function GoogleAuthCallback(): JSX.Element {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    const handleCallback = async (): Promise<void> => {
      try {
        const {
          data: { session },
          error,
        } = await supabase.auth.getSession();

        if (error) throw error;
        if (!session) throw new Error('No session found');

        if (session.provider_token && user) {
          await supabase.from('google_calendar_integrations').upsert({
            user_id: user.id,
            access_token: session.provider_token,
            refresh_token: session.provider_refresh_token,
            expires_at: new Date(
              Date.now() + (session.expires_in || 3600) * 1000,
            ).toISOString(),
          });

          toast.success('Google Calendar connected successfully');
        } else {
          console.error('No provider token found');
          toast.error('Failed to connect Google Calendar');
        }

        navigate('/settings/integrations');
      } catch (error) {
        console.error('Error handling Google Auth callback:', error);
        toast.error('Failed to connect Google Calendar');
        navigate('/settings/integrations');
      }
    };

    handleCallback().catch(console.error);
  }, [user, navigate]);

  return <div>Processing Google Calendar integration...</div>;
}
